import { Component, inject, Injectable, type OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NewplaBaseComponent2, NewplaPageUtils } from '@newpla/ng-common';
import { Bs5ModalCtrl } from '@newpla/ng-lib';
import { NpTaskAll } from '@newpla/ts-common';
import { CollectionView, NpFlexGridCtrl } from '@newpla/wijmo';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NpxCommonModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-common.module';
import { NpxFormsModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-forms.module';
import { NpxWijmoGridModule } from '../../../../newpla-npx-ng17/src/_shared-modules/npx-wijmo-grid.module';
import { SlsNovaPageLoading } from '../../config/sls-nova-page-loading';

@Injectable({
  providedIn: 'root'
})
export class PdiRequestCheckResultModalOpenService {
  private ngbModal = inject(NgbModal);
  openModal(requestCheckResult: any) {
    let modal = this.ngbModal.open(PdiRequestCheckResultModal, { size: 'lg', scrollable: true, backdrop: 'static' });
    modal.componentInstance.requestCheckResult = requestCheckResult;
    return modal.result;
  }
}

@Component({
  selector: 'app-pdi-request-check-result-modal',
  standalone: true,
  imports: [NpxCommonModule, NpxFormsModule, NpxWijmoGridModule],
  templateUrl: './pdi-request-check-result-modal.html',
  styleUrl: './pdi-request-check-result-modal.scss',
})

export class PdiRequestCheckResultModal extends NewplaBaseComponent2 {

  ///////////////////////////////////////////////////////////////////////////////////////////////////// BROWSER INIT
  browserInited: boolean = false;
  override browserNgOnInit = async () => {
    try {
      const taskAll = new NpTaskAll();
      taskAll.add(SlsNovaPageLoading.wait());
      await taskAll.run();

      this.modalInit();
      this.browserInited = true;
    } catch (e) {
      NewplaPageUtils.browserInitError(e);
      this.activeModal.dismiss();
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////// DATA 

  requestCheckResult: any;

  dataMap: any = {
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////// INJECT 

  activeModal = inject(NgbActiveModal);
  formBuilder = inject(FormBuilder);
  modalCtrl = new Bs5ModalCtrl({ drag: true, fullscreen: true });

  // 그리드 ///////////////////////////////////////////////////////////////////////////////////////////////////// 

  flexGrid1Cv: CollectionView = new CollectionView([], {});
  flexGrid1Ctrl: NpFlexGridCtrl = new NpFlexGridCtrl({
    selector: 'MULTI',
    flexGridId: window.location.pathname + '#pdiReqCheck#flexGrid1',
    excelDownload: false,
    excelFileName: 'PDI요청_WARNING'
  });

  async modalInit() {
    if (!this.requestCheckResult) this.requestCheckResult = [];
    this.flexGrid1Cv.sourceCollection = this.requestCheckResult;
  }

}
